import base64 from "base-64";
export const base64encode = (str: string) => {
  return base64.encode(str);
};
